/**
 * Inclusive JS breakpoint for Mi página's compact editor.
 *
 * The editor needs the app's expanded `xl` rail plus enough room for a useful live preview, so
 * it stays compact (full-screen mobile builder) through 1279px. The global shell (Layout) and
 * the builder itself must agree on this exact pixel: with two different breakpoints the shell
 * took 72px away from a desktop editor that had just mounted.
 */
export const STOREFRONT_COMPACT_MAX_WIDTH = 1279;
